module.exports = __webpack_public_path__ + "d93deb05bb0cd13b0dcb9b378b3b79e2.svg";